module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="center">\n    <a href="/api/document/view/'+
((__t=( id ))==null?'':__t)+
'" target="_blank" class="preview-doc" style="color:'+
((__t=( color ))==null?'':__t)+
';"><span class="clickable glyphicon glyphicon-eye-open"/></a>\n</td>\n<td class="center">\n    <a href="/api/document/download/'+
((__t=( id ))==null?'':__t)+
'" class="preview-doc" style="color:'+
((__t=( color ))==null?'':__t)+
';"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n</td>\n<td class="center"><input type="checkbox" class="child_checkbox" ';
 if (selected) { 
__p+=' checked ';
 } 
__p+=' ></td>\n<td><a href="/#document/'+
((__t=( id ))==null?'':__t)+
'" target="_blank">'+
((__t=( name ))==null?'':__t)+
'</a></td>\n<td>'+
((__t=( rnsBarCode ))==null?'':__t)+
'</td>\n<td>';
 if (patient) { 
__p+='<a href="/#person/'+
((__t=( patient.id ))==null?'':__t)+
'" target="_blank">'+
((__t=( toUpper(patient.name) ))==null?'':__t)+
'</a>';
 } else { 
__p+=' - ';
 } 
__p+='</td>\n<td class="center">'+
((__t=( fmCreatedTime ))==null?'':__t)+
'</td>\n<td class="center">'+
((__t=( fmDueTime ))==null?'':__t)+
'</td>\n<td class="center">'+
((__t=( fmSignedTime ))==null?'':__t)+
'</td>\n<td>';
 if (createdByObj) { 
__p+='<a href="'+
((__t=( createdByObj.url ))==null?'':__t)+
'" target="_blank">'+
((__t=( toUpper(createdByObj.name) ))==null?'':__t)+
'</a>';
 } 
__p+='</td>\n\n<td>\n    ';
 for (var i in object.reviewers) { 
__p+='\n\n    ';
 if (object.reviewers[i].organizationId != null) { 
__p+='\n    <a href="/#organization/'+
((__t=( object.reviewers[i].organizationId ))==null?'':__t)+
'" target="_blank">'+
((__t=( toUpper(reviewersNames()[object.reviewers[i].organizationId]) ))==null?'':__t)+
'</a>\n    ';
 } 
__p+='\n\n    ';
 if (object.reviewers[i].organizationId == null) { 
__p+='\n    <span/>\n    ';
 } 
__p+='\n\n    <br/>\n    ';
 } 
__p+='\n</td>\n<td>\n    ';
 for (var i in object.reviewers) { 
__p+='\n\n    ';
 if (object.reviewers[i].personId != null) { 
__p+='\n    <a href="/#person/'+
((__t=( object.reviewers[i].personId ))==null?'':__t)+
'" target="_blank">'+
((__t=( toUpper(reviewersNames()[object.reviewers[i].personId]) ))==null?'':__t)+
'</a>\n    ';
 } 
__p+='\n\n    ';
 if (object.reviewers[i].personId == null ) { 
__p+='\n    <span/>\n    ';
 } 
__p+='\n\n    <br/>\n    ';
 } 
__p+='\n</td>\n<td style="min-width: 120px;">'+
((__t=( (intention ? intention.toUpperCase() : intention) ))==null?'':__t)+
'</td>\n<td style="min-width: 140px;">'+
((__t=( (status ? status.toUpperCase() : status) ))==null?'':__t)+
'</td>\n';
 if (showSendingMethods) { 
__p+='\n<td>\n    ';
 (preferredSendingMethods() || []).forEach(function(method){ 
__p+='\n    ';
 if (method === 'EMAIL') { 
__p+=' <span class="glyphicon glyphicon-envelope sending-method" title="Email" data-toggle="tooltip"/> ';
 } else  if (method === 'FAX') {  
__p+='\n    <span class="glyphicon glyphicon-print sending-method" title="Fax" data-toggle="tooltip"/> ';
 } else  if (method === 'PHONE'){ 
__p+='\n    <span class="glyphicon glyphicon-earphone sending-method" title="Phone" data-toggle="tooltip"/> ';
 } else if (method === 'REVIEW_AND_SIGN') {  
__p+='\n    <span class="glyphicon glyphicon-home sending-method" title="Review And Sign" data-toggle="tooltip"/> ';
 } else if (method === 'HAND_DELIVERY') { 
__p+='\n    <span class="glyphicon glyphicon-hd-video sending-method" title="Hand Delivery" data-toggle="tooltip"/>';
 } else if (method === 'MEDICITY') {  
__p+='\n    <span class="sending-method" title="Direct Messaging" data-toggle="tooltip">XDR</span> ';
 } else { 
__p+='\n    <span>'+
((__t=( method ))==null?'':__t)+
'</span> ';
 } 
__p+='\n    ';
 }) 
__p+='\n</td>\n';
 } 
__p+='\n';
 if (hasCustomContacts) { 
__p+='\n<td class="center"><span class="glyphicon glyphicon-subtitles clickable custom-sending-methods" title="Document contacts"\n                         role="button" data-toggle="popover" data-placement="top" data-content=""/></td>\n';
 } else { 
__p+='\n<td class="center"><span class="glyphicon glyphicon-copyright-mark clickable sending-methods" title="Reviewer\'s contacts"\n                         role="button" data-toggle="popover" data-placement="top" data-content=""/></td>\n';
 } 
__p+='\n<td class="center">\n    <a href="/#document-history/'+
((__t=( id ))==null?'':__t)+
'" target="_blank" style="color:'+
((__t=( deliveryConf.deliveryColor ))==null?'':__t)+
';" title="'+
((__t=( deliveryConf.deliveryTitle ))==null?'':__t)+
'">\n        <span class="clickable glyphicon glyphicon-envelope"/>\n    </a>\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-item.html
// module id = 307
// module chunks = 0